import './styles.sass';

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import * as QueryParams from 'components/Explorer/models/query_params';
import useQueryParams from 'hooks/useQueryParams';

const Pagination = ({ lastPage = false, onChangePage }) => {
  const params = useQueryParams();

  const trackChange = (newPage) => {
    if (onChangePage) onChangePage(newPage);
  };

  const linkFor = (newPage) => ({ search: QueryParams.searchFor(QueryParams.withPage(params, newPage)) });

  const showPrevious = params.page > 1;
  const showNext = !lastPage;
  const showSeparator = showPrevious && showNext;

  return (
    <div className="Explorer-Pagination">
      {showPrevious && (
        <Link onClick={() => trackChange(params.page - 1)} to={linkFor(params.page - 1)} className="previous">
          &larr; {I18n.t('Explorer.Pagination.previous')}
        </Link>
      )}
      {showSeparator && <span className="separator">|</span>}
      {showNext && (
        <Link onClick={() => trackChange(params.page + 1)} to={linkFor(params.page + 1)} className="next">
          {I18n.t('Explorer.Pagination.next')} &rarr;
        </Link>
      )}
    </div>
  );
};

Pagination.propTypes = {
  lastPage: PropTypes.bool,
  onChangePage: PropTypes.func
};

export default Pagination;
